<template>
  <BaseDrawer
    :model-value="isOpen"
    :title="title"
    :description="description"
    max-width-class="max-w-md"
    @close="closeCart"
  >
    <DraftOrdersView />
  </BaseDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseDrawer from '~/components/shared/dialogs/BaseDrawer.vue'
import DraftOrdersView from '~/components/DraftOrdersView.vue'
import { useCartStore } from '~/stores/useCartStore'

withDefaults(
  defineProps<{
    /** Controls whether the drawer is visible. */
    isOpen?: boolean
  }>(),
  { isOpen: false }
)

const emit = defineEmits<{ close: [] }>()

const { t } = useI18n()

const cartStore = useCartStore()

const draftCount = computed(() => cartStore.draftOrders.length)

// The count is the shell title and the explanation its description.
const title = computed(() =>
  draftCount.value > 0
    ? t('commerce.draftOrdersView.draftCartsCount', { count: draftCount.value })
    : t('commerce.draftOrdersDrawer.title')
)

const description = computed(() =>
  draftCount.value > 0 ? t('commerce.draftOrdersView.continueYourOrdersFromDifferentStores') : ''
)

const closeCart = () => {
  cartStore.closeDraftOrdersCart()
  emit('close')
}
</script>
